// FILE: src/reducers/dashboard_reducers/warehouse/retrieve_warehouse_inventory_physical_storage_product_details_Slice.js

import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  retrieve_warehouse_inventory_physical_storage_product_details: {
    status: app_consts.IDLE,
    message: "",
    data: null,
  },
};

const retrieve_warehouse_inventory_physical_storage_product_details_Slice = createSlice({
  name: "retrieve_warehouse_inventory_physical_storage_product_details",
  initialState,
  reducers: {
    loading_retrieve_warehouse_inventory_physical_storage_product_details: (state) => {
      state.retrieve_warehouse_inventory_physical_storage_product_details.status = app_consts.LOADING;
      state.retrieve_warehouse_inventory_physical_storage_product_details.message = "";
      state.retrieve_warehouse_inventory_physical_storage_product_details.data = null;
    },

    success_retrieve_warehouse_inventory_physical_storage_product_details: (state, action) => {
      state.retrieve_warehouse_inventory_physical_storage_product_details.status = app_consts.SUCCESS;
      state.retrieve_warehouse_inventory_physical_storage_product_details.message = action?.payload?.message || "";
      state.retrieve_warehouse_inventory_physical_storage_product_details.data =
        action?.payload?.data ?? action?.payload ?? null;
    },

    fail_retrieve_warehouse_inventory_physical_storage_product_details: (state, action) => {
      state.retrieve_warehouse_inventory_physical_storage_product_details.status = app_consts.FAIL;
      state.retrieve_warehouse_inventory_physical_storage_product_details.message =
        action?.payload?.message ||
        action?.payload ||
        "Failed to retrieve warehouse inventory physical storage product details.";
      state.retrieve_warehouse_inventory_physical_storage_product_details.data = null;
    },

    reset_retrieve_warehouse_inventory_physical_storage_product_details: (state) => {
      state.retrieve_warehouse_inventory_physical_storage_product_details.status = app_consts.IDLE;
      state.retrieve_warehouse_inventory_physical_storage_product_details.message = "";
      state.retrieve_warehouse_inventory_physical_storage_product_details.data = null;
    },
  },
});

export const {
  loading_retrieve_warehouse_inventory_physical_storage_product_details,
  success_retrieve_warehouse_inventory_physical_storage_product_details,
  fail_retrieve_warehouse_inventory_physical_storage_product_details,
  reset_retrieve_warehouse_inventory_physical_storage_product_details,
} = retrieve_warehouse_inventory_physical_storage_product_details_Slice.actions;

export default retrieve_warehouse_inventory_physical_storage_product_details_Slice.reducer;
